import { createAction } from 'shared/utils';

export const CONFIG_SUBDIVISION_PAGE_REFRESH = 'CONFIG_SUBDIVISION_PAGE_REFRESH';
export const CONFIG_SUBDIVISION_GETS = createAction('CONFIG_SUBDIVISION_GETS');
export const CONFIG_SUBDIVISION_ADD = createAction('CONFIG_SUBDIVISION_ADD');
export const CONFIG_SUBDIVISION_UPDATE = createAction('CONFIG_SUBDIVISION_UPDATE');
export const CONFIG_SUBDIVISION_DELETE = createAction('CONFIG_SUBDIVISION_DELETE');
